import { ConfirmationModal, DsfrModal } from '@common/ui';
import React, { useEffect, useState } from 'react';

const defaultSeconds = 3;

export const ApprobationHabilitationConfirmationModal = ({
                                                           dsfrModal,
                                                           isOpen,
                                                           message,
                                                           onClose,
                                                           onConfirm,
                                                           isRefusing,
                                                         }: ApprobationHabilitationConfirmationModalProps) => {
  const [seconds, setSeconds] = useState<number>(defaultSeconds);
  const [paused, setPaused] = useState<boolean>(false);
  const [commentaire, setCommentaire] = useState('');

  useEffect(() => {
    setSeconds(defaultSeconds);
    setPaused(!isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (seconds <= 0 || paused) return;

    const intervalId = setInterval(() => setSeconds(prev => prev - 1), 1_000);

    return () => clearInterval(intervalId);
  }, [seconds, paused]);

  return (
    <ConfirmationModal dsfrModal={dsfrModal}
                       description={message}
                       cancelProps={{ onClick: onClose }}
                       confirmProps={{
                         label: `CONFIRMER${seconds > 0 ? ` (${seconds}s)` : ''}`,
                         disabled: (seconds > 0),
                         onClick: () => commentaire.length ? onConfirm(commentaire) : onConfirm(),
                       }}>
      {isRefusing && (
        <div className="form-field">
          <textarea
            className="form-field-input"
            placeholder={'Laissez un commentaire sur le refus. (Optionnel)'}
            value={commentaire}
            onChange={(event) => setCommentaire(event.target.value)}
          />
        </div>
      )}

    </ConfirmationModal>
  );
};

interface ApprobationHabilitationConfirmationModalProps {
  dsfrModal: DsfrModal;
  isOpen: boolean;
  message: string;
  onClose: () => void;
  onConfirm: (commentaire?: string) => void;
  isRefusing: boolean;
}